import React, { useEffect, useState } from 'react';
import { Smartphone } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';

const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export const InstallAppButton = () => {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    const onInstalled = () => setInstalled(true);
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  if (installed || (!prompt && !isIOS())) return null;

  const install = async () => {
    if (!prompt) {
      toast.info('Su iPhone/iPad: tocca Condividi e poi "Aggiungi a schermata Home"', { duration: 8000 });
      return;
    }
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === 'accepted') setInstalled(true);
    setPrompt(null);
  };

  return (
    <Button variant="outline" onClick={install} data-testid="install-app-btn" className="border-blue-600 text-blue-700">
      <Smartphone className="w-4 h-4 mr-2" />
      Installa app
    </Button>
  );
};

export default InstallAppButton;
